"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class AjaxAddToCartButton extends HTMLElement {
    constructor() {
        super();
        const variantid = this.dataset.variantid ? parseInt(this.dataset.variantid) : '';
        if (!variantid) {
            this.innerText = '未能加入購物車';
            return;
        }
        const self = this;
        this.addEventListener('click', () => __awaiter(this, void 0, void 0, function* () {
            try {
                self.showSpinner(this);
                const variantid = this.dataset.variantid ? parseInt(this.dataset.variantid) : '';
                if (!variantid)
                    return;
                const response = yield moobiQueries.addCartItem([{ variantId: variantid, quantity: 1 }]);
                if ((response === null || response === void 0 ? void 0 : response.status) === 442 || (response === null || response === void 0 ? void 0 : response.status) === 422) {
                    self.hideSpinner(this, '未能加入購物車');
                    return;
                }
                self.hideSpinner(this, '已加入購物車');
                const productDataArray = MoobiAdaptors.adaptorShopifyAjaxAddCartResponseToData(response.items);
                CartNotificationModifier.closeNotification();
                const notificationModifier = new CartNotificationModifier(productDataArray);
                gTag_add_to_cartHandler(response.items);
                this.reloadOnCartPage();
            }
            catch (error) {
                console.log(error);
            }
        }));
    }
    hideSpinner(elm, innerText) {
        setTimeout(() => {
        }, (2000));
        const spinner = elm.querySelector('.loading-overlay__spinner');
        const span = elm.querySelector('span');
        spinner === null || spinner === void 0 ? void 0 : spinner.classList.add('hidden');
        span.innerText = innerText;
    }
    showSpinner(elm) {
        const spinner = elm.querySelector('.loading-overlay__spinner');
        const span = elm.querySelector('span');
        spinner === null || spinner === void 0 ? void 0 : spinner.classList.remove('hidden');
        const innerText = span.innerText;
        span.innerText = '';
        return innerText;
    }
    reloadOnCartPage() {
        if (window.location.pathname.includes('cart'))
            // window.location.reload()
            moobiQueries.renderMainCart();
    }
}
class MoobiProductCard {
    constructor(productData, cardOptions) {
        // this.shopifyProductData = {
        //     handle: "",
        //     images: [],
        //     title: "",
        //     vendor: "",
        //     price: 0,
        //     defaultVariantId: 0,            
        //     url: "",
        //     image: "",
        //     image_X100: "",
        //     image_X200: "",
        //     image_X300: "",
        //     image_X400: "",
        //     image_X600: ""
        // }
        // console.log(productData)
        // console.log(cardOptions.targetElm)
        this.shopifyProductData = productData;
        this.cardOptions = cardOptions;
    }
    createCard() {
        let insertedDataElm = this.insertProductData();
        insertedDataElm = this.initVariantsSelector(insertedDataElm);
        return insertedDataElm;
    }
    initVariantsSelector(elm) {
        if (this.cardOptions.variantSelector.on) {
            return this.insertVariantSelector(elm);
        }
        else {
            return elm;
        }
    }
    insertProductData() {
        const options = this.cardOptions;
        const data = this.shopifyProductData;
        const target = options.targetElm;
        const keysArray = Array.from(options.renderMap.keys());
        keysArray.forEach((el) => {
            const identier = options.renderMap.get(el).identifier;
            const attribute = options.renderMap.get(el).attribute;
            const subTarget = target.querySelector(identier);
            /* bypass typecheck to edit attributes */
            if (subTarget) {
                let dataValue = data[el];
                // format prices
                if (el.includes('price') && typeof dataValue === 'number') {
                    dataValue = MoobiUtilities.formatShopifyPrice(dataValue);
                }
                // to deal with datasets
                if (attribute.includes('dataset')) {
                    const key = attribute.replace('dataset.', '');
                    subTarget.dataset[key] = dataValue;
                }
                else {
                    if (dataValue) {
                        subTarget[attribute] = dataValue;
                    }
                }
            }
        });
        return target;
    }
    insertVariantSelector(target) {
        if (this.checkVariants())
            return target;
        const selector = this.createSelectorElm();
        const insertedTarget = this.insertSelectorElm(target, selector);
        return insertedTarget;
    }
    variantSelectorHanlder(idValue) {
        // change price
        this.changePriceByVariantId(idValue);
        // change datasetId
        this.changedataSetIdByVariantId(idValue);
    }
    createSelectorElm() {
        const variants = this.shopifyProductData.variants;
        if (!variants)
            return;
        const selector = document.createElement('select');
        const optionsArray = variants.map((el) => {
            const option = document.createElement('option');
            option.value = el.id.toString();
            option.innerText = el.title;
            return option;
        });
        optionsArray.forEach((el) => {
            selector.insertAdjacentElement('afterbegin', el);
        });
        selector.addEventListener('change', () => {
            const id = selector.value;
            this.variantSelectorHanlder.apply(this, [id]);
        });
        return selector;
    }
    insertSelectorElm(target, selector) {
        const addButtonIdentifier = this.cardOptions.renderMap.get('defaultVariantId');
        if (!addButtonIdentifier || !selector) {
            return target;
        }
        const targetElm = target.querySelector(addButtonIdentifier.identifier);
        targetElm.insertAdjacentElement('beforebegin', selector);
        return target;
    }
    changePriceByVariantId(idValue) {
        const priceIdentifier = this.cardOptions.renderMap.get('price');
        const comparePriceIdentifier = this.cardOptions.renderMap.get('compare_at_price');
        if (!priceIdentifier || !comparePriceIdentifier)
            return;
        const priceElm = this.cardOptions.targetElm.querySelector(priceIdentifier.identifier);
        const comparePriceElm = this.cardOptions.targetElm.querySelector(comparePriceIdentifier.identifier);
        if (!this.shopifyProductData.variants)
            return;
        const matchingVariant = this.shopifyProductData.variants.filter((el) => {
            if (el.id.toString() === idValue) {
                return true;
            }
        });
        const newPrice = { price: matchingVariant[0].price, comparedAt: matchingVariant[0].compare_at_price };
        if (!newPrice)
            return;
        priceElm[priceIdentifier.attribute] = MoobiUtilities.formatShopifyPrice(newPrice.price);
        if (!newPrice.comparedAt) {
            comparePriceElm[comparePriceIdentifier.attribute] = '';
        }
        else {
            comparePriceElm[comparePriceIdentifier.attribute] = MoobiUtilities.formatShopifyPrice(newPrice.comparedAt);
        }
    }
    changedataSetIdByVariantId(idValue) {
        const addButtonIdentifier = this.cardOptions.renderMap.get('defaultVariantId');
        if (!addButtonIdentifier)
            return;
        const addElm = this.cardOptions.targetElm.querySelector(addButtonIdentifier.identifier);
        const key = addButtonIdentifier.attribute.replace('dataset.', '');
        addElm.dataset[key] = idValue;
    }
    // checks
    checkVariants() {
        return (!this.shopifyProductData.variants || this.shopifyProductData.variants.length < 2);
    }
}
class CartNotificationModifier {
    constructor(productDataArray) {
        this.productDataArray = productDataArray;
        this.cartNotoficationElm = document.querySelector('cart-notification');
        this.initModification();
    }
    initModification() {
        return __awaiter(this, void 0, void 0, function* () {
            const cartItems = yield moobiQueries.getCartItems();
            const dataArray = this.productDataArray;
            const clones = dataArray.map((el) => {
                const clone = this.returnNotificationItemClone();
                this.modifyNotificationItemClone(el, clone);
                return clone;
            });
            this.clearNotificationItems();
            this.insertModifiedClone(clones);
            this.openNotification();
            this.cleanUpNotification();
            // const renderCart = new RenderCartItems()
        });
    }
    returnNotificationItemClone() {
        const cartNotificationItem = document.createElement('div');
        cartNotificationItem.classList.add('cart-notification-product');
        const imageWrapper = document.createElement('div');
        imageWrapper.classList.add('cart-notification-product__image');
        imageWrapper.classList.add('global-media-settings');
        const image = document.createElement('img');
        image.width = 70;
        image.height = 70;
        imageWrapper.insertAdjacentElement('beforeend', image);
        const h3 = document.createElement('h3');
        const divElm = document.createElement('div');
        h3.classList.add('cart-notification-product__name');
        h3.classList.add('h4');
        const dl = document.createElement('dl');
        divElm.insertAdjacentElement('beforeend', h3);
        divElm.insertAdjacentElement('beforeend', dl);
        cartNotificationItem.insertAdjacentElement('beforeend', imageWrapper);
        cartNotificationItem.insertAdjacentElement('beforeend', divElm);
        return cartNotificationItem;
    }
    modifyNotificationItemClone(productData, clone) {
        const img = clone.querySelector('img');
        const title = clone.querySelector('h3');
        img.src = productData.image_X100;
        title.innerText = productData.title;
    }
    insertModifiedClone(clones) {
        const header = this.cartNotoficationElm.querySelector('.cart-notification__header');
        clones.forEach((el) => {
            header.insertAdjacentElement('afterend', el);
        });
    }
    openNotification() {
        const notification = this.cartNotoficationElm;
        notification.open();
    }
    static openNotification() {
        const notification = document.querySelector('cart-notification');
        notification.open();
    }
    static closeNotification() {
        const notification = document.querySelector('cart-notification');
        notification.close();
    }
    cleanUpNotification() {
        this.observeCartNotificationMutation(this.clearNotificationItems.bind(this));
    }
    observeCartNotificationMutation(handler) {
        const targetNode = document.querySelector('#cart-notification');
        const config = { attributes: true, childList: true, subtree: true };
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                handler();
                observer.disconnect();
            });
        });
        observer.observe(targetNode, config);
    }
    clearNotificationItems() {
        const items = this.cartNotoficationElm.querySelectorAll('.cart-notification-product');
        items.forEach((el) => {
            if (el.id === 'cart-notification-product') {
                el.innerHTML = '';
            }
            else {
                el.remove();
            }
        });
    }
}
class BulkAddToCartController {
    constructor(produtDataArray, buttonIdentifier) {
        this.productDataArray = produtDataArray;
        this.button = document.querySelector(buttonIdentifier);
        this.initBulkAddButton();
    }
    initBulkAddButton() {
        return __awaiter(this, void 0, void 0, function* () {
            this.button.addEventListener('click', () => __awaiter(this, void 0, void 0, function* () {
                try {
                    this.loadingHandler();
                    const response = yield this.bulkAddToCart();
                    setTimeout(() => {
                        if (response && response.items) {
                            this.loadingCompletedHandler('己加入購物車');
                            const notificationModifier = new CartNotificationModifier(this.productDataArray);
                            gTag_add_to_cartHandler(response.items);
                        }
                        else {
                            console.log(response);
                            this.loadingCompletedHandler('部分貨品暫時售罄，未能加入購物車');
                            this.button.disabled = true;
                        }
                    }, 150);
                }
                catch (error) {
                    // this.loadingCompletedHandler()
                    console.log(error);
                    this.loadingCompletedHandler('部分貨品暫時售罄，未能加入購物車');
                    this.button.disabled = true;
                }
            }));
        });
    }
    bulkAddToCart() {
        return __awaiter(this, void 0, void 0, function* () {
            const itemsArray = this.productDataArray.map((el) => {
                const item = {
                    variantId: el.defaultVariantId,
                    quantity: el.quantity || 1
                };
                return item;
            });
            const response = yield moobiQueries.addCartItem(itemsArray);
            return response;
        });
    }
    loadingHandler() {
        const spinner = this.button.querySelector('.loading-overlay__spinner');
        if (!spinner)
            return;
        spinner.classList.remove('hidden');
        const span = this.button.querySelector('span');
        if (!span)
            return;
        span.innerText = '';
    }
    loadingCompletedHandler(text) {
        const spinner = this.button.querySelector('.loading-overlay__spinner');
        if (!spinner)
            return;
        spinner.classList.add('hidden');
        const span = this.button.querySelector('span');
        if (!span)
            return;
        span.innerText = text;
    }
}
customElements.define('ajax-addtocartbutton', AjaxAddToCartButton);
